import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  isLogged: false,
  user: null,
  savedFilter: false,
  sortBy: "",
  modalClosedTime: null,
  commentor: {},
  modalPopup: false,
  listingFilter: null,
  defaultSearch: true,
  scrollPosition: null,
  propertyDetails: null,
  filterOptions: {
    query: "",
    amenities: [],
    searchAmenities: "",
    squarefeet: null,
    leasing_end_month: null,
    listing_type: null,
    sqft_min: null,
    sqft_max: null,
    minlot: null,
    maxlot: null,
    moveDate: null,
    minyearbuilt: null,
    maxyearbuilt: null,
    leasing_end_min: null,
    leasing_end_max: null,
    page: 1,
    page_size: 20,
    page_url: null,
    beds: null,
    baths: null,
    unit_listing: null,
  },
  portfolioFilter: {
    city: "",
    zip_codes: "",
    owners: "",
    owners_name: "",
  },
  comparablesYearBuilt: [],
  tableSort: { key: null, direction: "asc" },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    LoginSuccess: (state, action) => {
      state.isLogged = true;
      state.user = action.payload;
      // SetLoginCredentials(action.payload.access, action.payload.refresh);
    },
    LogoutHandler: (state) => {
      state.user = null;
      state.isLogged = false;
      state.profile = null;
      state.commentor = null;
      state.savedFilter = false;
      state.propertyDetails = null;
      state.sortBy = "";
      state.filterOptions = initialState.filterOptions;
      state.portfolioFilter = initialState.portfolioFilter;
      sessionStorage.removeItem("scrollPosition");
    },
    updateUserProfile: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        if (state.user.hasOwnProperty(key)) {
          state.user[key] = action.payload[key];
        }
      });
    },
    updateSavedFilter: (state, action) => {
      state.savedFilter = action.payload;
    },
    updatelistingFilter: (state, action) => {
      state.listingFilter = action.payload;
    },
    updateSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setModalClosedTime: (state, action) => {
      state.modalClosedTime = action.payload;
    },
    updateCommentor: (state, action) => {
      state.commentor = action.payload;
    },
    updateModalPopup: (state, action) => {
      state.modalPopup = action.payload;
    },
    updateDefaultSearch: (state, action) => {
      state.defaultSearch = action.payload;
    },
    updateScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
    updatePropertyDetails: (state, action) => {
      state.propertyDetails = action.payload;
    },
    updateFilter: (state, action) => {
      state.filterOptions = { ...state.filterOptions, ...action.payload };
    },
    resetFilters: (state) => {
      state.portfolioFilter = initialState.portfolioFilter;
    },
    updatePortfolioFilter: (state, action) => {
      state.portfolioFilter = { ...state.portfolioFilter, ...action.payload };
    },
    resetPortfolioFilters: (state) => {
      state.portfolioFilter = initialState.portfolioFilter;
    },
    getNewYearBuilt: (state, action) => {
      state.comparablesYearBuilt = [
        ...new Set([...state.comparablesYearBuilt, action.payload]),
      ];
    },
    updateSortTable: (state, action) => {
      state.tableSort = action.payload;
    },
    resetSortTable: (state) => {
      state.tableSort = initialState.tableSort;
    },
  },
});

export const {
  LoginSuccess,
  LogoutHandler,
  updateUserProfile,
  updateSavedFilter,
  updateSortBy,
  setModalClosedTime,
  updateCommentor,
  updateModalPopup,
  updatelistingFilter,
  updateDefaultSearch,
  updateScrollPosition,
  updatePropertyDetails,
  updateFilter,
  resetFilters,
  updatePortfolioFilter,
  resetPortfolioFilters,
  getNewYearBuilt,
  updateSortTable,
  resetSortTable,
} = userSlice.actions;

export default userSlice.reducer;
